import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API } from "./api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const navigate = useNavigate();
    const processed = useRef(false);

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;

        const hash = window.location.hash || "";
        const m = hash.match(/session_id=([^&]+)/);
        if (!m) {
            navigate("/", { replace: true });
            return;
        }
        const session_id = decodeURIComponent(m[1]);

        (async () => {
            try {
                await axios.post(
                    `${API}/auth/session`,
                    { session_id },
                    { withCredentials: true }
                );
                // iter-102 — if a checkout was pending pre-auth, resume it
                // immediately so the user lands on Stripe instead of Home.
                // Stash is set by PremiumModal.checkout() on 401.
                let resumeProductId = null;
                try {
                    const stashed = window.sessionStorage.getItem("moodcard.pending_checkout");
                    if (stashed) {
                        const parsed = JSON.parse(stashed);
                        // Honor only if stashed in the last 10 minutes (sanity)
                        if (parsed?.product_id && (Date.now() - (parsed.ts || 0)) < 600_000) {
                            resumeProductId = parsed.product_id;
                        }
                        window.sessionStorage.removeItem("moodcard.pending_checkout");
                    }
                } catch { /* ignore */ }
                if (resumeProductId) {
                    try {
                        const { data } = await axios.post(
                            `${API}/checkout/premium`,
                            { product_id: resumeProductId, origin_url: window.location.origin },
                            { withCredentials: true }
                        );
                        if (data?.url) {
                            window.location.href = data.url;
                            return;
                        }
                    } catch (e) {
                        console.warn("resume checkout failed; falling back to home", e);
                    }
                }
                // Default landing: hard reload to / so AuthProvider runs /auth/me fresh
                window.location.replace("/");
            } catch (e) {
                console.error("auth exchange failed", e);
                navigate("/", { replace: true });
            }
        })();
    }, [navigate]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-[#050507]">
            <span className="font-sans text-xs uppercase tracking-[0.3em] text-white/40">
                signing you in…
            </span>
        </div>
    );
}
